<template>
    <section>
        <h1>NotFound</h1>
    </section>
</template>

<script>
    export default {
        name: "NotFound",
    }
</script>

<style scoped>

</style>
